export enum MODULES {
  PORTFOLIO = 'PORTFOLIO',
  RUG = 'RUG',
  AIVA = 'AIVA',
  COMPANY = 'COMPANY',
  DATA_STUDIO = 'DATA_STUDIO',
  FINANCIAL = 'FINANCIAL',
  SHELL_ADMIN = 'SHELL_ADMIN',
}
